export const componentLoader = <T>(lazyComponent: () => Promise<T>, attemptsLeft = 3) => {
  return new Promise<T>((resolve, reject) => {
    lazyComponent()
      .then(resolve)
      .catch((error: unknown) => {
        // If the error is due to a failed fetch of a dynamically imported module, reload the page on the last attempt
        if (String(error).includes('Failed to fetch dynamically imported module') && attemptsLeft === 1) {
          window.location.reload();
        }

        // retry after 1500 ms
        setTimeout(() => {
          if (attemptsLeft === 1) {
            reject(
              new Error('Component loader: retry attempts exhausted', {
                cause: error,
              })
            );
          } else {
            componentLoader(lazyComponent, attemptsLeft - 1).then(resolve, reject);
          }
        }, 1500);
      });
  });
};
